import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { I18n } from 'react-redux-i18n';

// Components.
import WelltoryButton from 'components/Welltory/Button';
import UserPicture from 'components/UserPicture';

// Utils.
import { isAndroidOS, isIOS } from 'utils';

import  { appURL } from 'config/index';

// Images.
import { ReactComponent as Logo } from './images/logo.svg';

// Styles.
import styles from './styles.module.scss';

export default class DashboardSharedInfo extends Component {

  onClickTryWelltoryButton = () => {
    this.props.onClickTryWelltoryButton();
  };

  render() {
    const { auth, profile } = this.props;
    if (auth.userType !== 'share') {
      return null;
    }

    let url;
    const isAndroidOSStatus = isAndroidOS();
    const isIOSStatus = isIOS();
    if (isAndroidOSStatus === true) {
      url = "http://app.appsflyer.com/com.welltory.client.android?pid=share";
    }
    else if (isIOSStatus === true) {
      url = "http://app.appsflyer.com/id1074367771?pid=share";
    }
    else {
      url = `${appURL}/auth/signin/`;
    }
    return (
      <Grid container className={styles.wrapper} spacing={16}>
        <Hidden mdUp>
          <Grid item xs={12} className={styles.colLogo}>
            <div className={styles.logo}>
              <Logo />
            </div>
          </Grid>
        </Hidden>
        <Grid item xs={12} md={9} sm={9} className={[styles.col]}>
          <div className={styles.userInfo}>
            <div className={styles.userInfoPictureWrapper}>
              <UserPicture profile={profile} isShowModal={false}/>
            </div>
            <div className={styles.userInfoMessage}>
              <span className={styles.userInfoUsername}>{profile.username}</span> {I18n.t('делится своей аналитикой из приложения Welltory Вы тоже можете узнать о себе больше вместе с нами')}
            </div>
          </div>
        </Grid>
        <React.Fragment>
          <Grid item xs={12} md={3} sm={3} className={[styles.col, styles.buttons]}>
            <WelltoryButton
              type="link"
              to={url}
              onClick={this.onClickTryWelltoryButton}
              className={styles.tryWelltoryButton}
            >
              {I18n.t('Попробовать Welltory')}
            </WelltoryButton>
            <div className={styles.textAfterButton}>{I18n.t('Это бесплатно!')}</div>
          </Grid>
        </React.Fragment>
      </Grid>
    );
  }

}
